import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ALL_CATEGORIES } from "@/contexts/ServiceContext";
import React from "react";
import { useServiceCategories } from "../hooks/categories.hooks";
import { useHotel } from "@/hooks/useHotel";

const ServiceCategoryField = ({
  value,
  onChange,
  className,
  disabled = false,
  withNullValue = true,
  error,
}: {
  error?: string;
  withNullValue?: boolean;
  value?: string;
  className?: string;
  disabled?: boolean;
  onChange: (value: string) => void;
}) => {
  const { hotelId } = useHotel();
  const { data, isLoading } = useServiceCategories({ hotelId });

  return (
    <>
      <Select disabled={disabled} value={value} onValueChange={onChange}>
        <SelectTrigger className={className || ""}>
          <SelectValue placeholder={isLoading ? "Loading..." : "Categories"} />
        </SelectTrigger>
        <SelectContent>
          {withNullValue && (
            <SelectItem value={ALL_CATEGORIES}>All categories</SelectItem>
          )}
          {Object.values(data?.items || []).map((item) => (
            <SelectItem key={item.id} value={item.id}>
              {item.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {error && <p className={"text-sm text-red-500"}>{error}</p>}
    </>
  );
};

export default ServiceCategoryField;
